<template>
  <div>
    <div
      class="Sensitivity"
      v-loading="loading"
      element-loading-background="rgba(16,164,178, 0.2)"
    >
      <!-- 左边区域 -->
      <div class="Sensitivity_left">
        <v-highlight-component :message="analyze" :search="textData" />
      </div>
      <!-- 右边区域 -->
      <div class="Sensitivity_right" ref="wordcloud"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
export default {
  data() {
    return {
      loading: false,
      textData: [],
      // 词云
      ciYun: [],
    };
  },
  props: ["analyze"],
  components: {},
  computed: {},
  beforeMount() {},
  mounted() {
    this.senRent();
  },
  methods: {
    async senRent() {
      this.loading = true;
      let data = { content: this.analyze };
      const { data: res } = await this.$http.post("/nlpir/keyScanner", data);
      // console.log(res);
      this.loading = false;
      this.textData = res.illegal.keys;
      let min = res.illegal.classes;
      JSON.stringify(min).replace(/value/g, "Weight");
      JSON.stringify(min).replace(/name/g, "Word");
      var val = [];
      var name = [];
      var newDate = [];
      for (let i = 0; i < min.length; i++) {
        val.push(min[i].weight);
        name.push(min[i].word);
        var obj = {
          value: min[i].weight,
          name: min[i].word,
        };
        newDate.push(obj);
      }
      this.ciYun = newDate;
      // 启动echarts
      this.echartsCiyun();
    },

    echartsCiyun() {
      let sensitivityt_echarts = echarts.init(this.$refs.wordcloud);
      sensitivityt_echarts.setOption({
        title: {
          text: "敏感词类型:",
          subtext: "",
          left: 10,
          top: 10,
          textStyle: {
            fontSize: 14,
            fontFamily: "Microsoft YaHei",
            color: "#fff", // 主标题文字颜色
          },
        },
        series: [
          {
            type: "wordCloud",
            // 网格大小，各项之间间距
            gridSize: 10,
            // 形状 circle 圆，cardioid  心， diamond 菱形，
            // triangle-forward 、triangle 三角，star五角星
            shape: "circle",
            // 字体大小范围
            sizeRange: [12, 50],
            // 文字旋转角度范围
            rotationRange: [0, 90],
            // 旋转步值
            rotationStep: 90,
            // 自定义图形
            // maskImage: maskImage,
            left: "center",
            top: "center",
            right: null,
            bottom: null,
            // 画布宽
            width: "90%",
            // 画布高
            height: "80%",
            // 是否渲染超出画布的文字
            drawOutOfBound: false,
            textStyle: {
              normal: {
                color: function () {
                  return (
                    "rgb(" +
                    [
                      Math.round(Math.random() * 200 + 55),
                      Math.round(Math.random() * 200 + 55),
                      Math.round(Math.random() * 200 + 55),
                    ].join(",") +
                    ")"
                  );
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: "#2ac",
              },
            },
            data: this.ciYun,
          },
        ],
      });
      window.onresize = function () {
        sensitivityt_echarts.resize();
      };
    },
  },
  watch: {},
};
</script>
<style lang= "less" scoped>
.Sensitivity {
  width: 100%;
  height: 360px;
  // border: 1px solid #fff;
  // margin: 10px 0px 0px 30px;
  box-sizing: border-box;
  .Sensitivity_left {
    width: 50%;
    height: 360px;
    // border: 1px solid #fff;
    box-sizing: border-box;
    float: left;
    color: #fff;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: auto;
    font-family: serif;
    border-right: 1px solid #10a4b2;
  }
  .Sensitivity_right {
    width: 48%;
    height: 360px;
    // border: 1px solid #fff;
    box-sizing: border-box;
    float: right;
  }
}
</style>
